/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthResetPasswordRequestBodyAllOf } from './AuthResetPasswordRequestBodyAllOf';
import {
    AuthResetPasswordRequestBodyAllOfFromJSON,
    AuthResetPasswordRequestBodyAllOfFromJSONTyped,
    AuthResetPasswordRequestBodyAllOfToJSON,
} from './AuthResetPasswordRequestBodyAllOf';

/**
 * 
 * @export
 * @interface AuthResetPasswordRequestBody
 */
export interface AuthResetPasswordRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AuthResetPasswordRequestBody
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthResetPasswordRequestBody
     */
    verifyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthResetPasswordRequestBody
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the AuthResetPasswordRequestBody interface.
 */
export function instanceOfAuthResetPasswordRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthResetPasswordRequestBodyFromJSON(json: any): AuthResetPasswordRequestBody {
    return AuthResetPasswordRequestBodyFromJSONTyped(json, false);
}

export function AuthResetPasswordRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthResetPasswordRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'verifyCode': !exists(json, 'verifyCode') ? undefined : json['verifyCode'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function AuthResetPasswordRequestBodyToJSON(value?: AuthResetPasswordRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'verifyCode': value.verifyCode,
        'newPassword': value.newPassword,
    };
}

